<div mat-dialog-title>
  <div class="d-flex justify-content-end">
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="onClose()"
    ></button>
  </div>
</div>

<div mat-dialog-content class="container-fluid px-2">
  <div class="d-flex flex-column flex-md-row align-items-center">
    <qrcode
      [qrdata]="qrcodeData"
      [width]="256"
      [errorCorrectionLevel]="'M'"
    ></qrcode>

    <p class="pt-4 text-wrap fs-lg fw-bold text-center">
      Scan the QR code below to complete the <br />
      transaction using your mobile wallet <br />
      application. After the transaction is <br />
      complete, you will receive an email <br />
      confirmation from Easykash for your purchase.
      <br />
    </p>
  </div>

  <div class="mt-4">
    <p class="text-center">
      <strong>OR</strong><br />
      Can't scan the QR code? send payment request to entered mobile number
    </p>

    <form [formGroup]="requestToPayForm" class="w-100">
      <div class="mb-3">
        <input type="text" formControlName="phone" class="form-control" placeholder="Enter phone number" />
        <span style="color: red" *ngIf="formValidator.formErrors.phone">
          {{ formValidator.formErrors.phone }}
        </span>
      </div>

      <div class="d-grid">
      <button class="col-12 btn btn-success" (click)="requestToPay()">
        Request
      </button>
      </div>
    </form>
  </div>
</div>

<div mat-dialog-actions></div>
